import React from 'react';
import PropTypes from 'prop-types';

const Star = ({ size, color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill={color}
    viewBox="0 0 16 16"
  >
    <path d="M8.533.391a.56.56 0 0 0-1.066 0l-1.44 4.345c-.101.305-.273.582-.501.808s-.508.397-.815.497L.392 7.451c-.523.171-.523.927 0 1.098L4.71 9.958c.307.1.586.271.815.497s.4.504.501.808l1.44 4.345a.56.56 0 0 0 1.066 0l1.44-4.345c.101-.305.273-.582.501-.808s.508-.397.815-.497l4.319-1.409c.523-.171.523-.927 0-1.098L11.29 6.042c-.307-.1-.586-.271-.815-.497s-.4-.504-.501-.808L8.533.391z" />
  </svg>
);

Star.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  color: PropTypes.string.isRequired,
};

export default Star;
